import RenderLoader from '../RenderLoader';

const renderLoader = (props) => {
    const overlayStyle = { ...{ position: 'absolute', left: 0, top: 0, bottom: 0, right: 0, background: 'rgba(0,0,0,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }, ...props.style }
    return (
        <div style={overlayStyle}><RenderLoader style={props.loaderStyle}/></div>
    );
};

export default renderLoader;
